import { Radio, RadioGroup } from "@headlessui/react";
import { Fragment } from "react";
import { Divider, Typography } from "@/components/atoms";
import { SoloScenarioId, scenarioAnswers, scenarioHint } from "../data/driverAppScenarios";

export interface DriverAppScenarioPickerProps {
  value: SoloScenarioId | null;
  onSelect: (scenario: SoloScenarioId) => void;
}

/**
 * The one question step 2 asks. Built on headless-ui's RadioGroup — same composition as the
 * RadioButtonGroup atom — so the answers carry radio semantics rather than reading as plain cards.
 */
export const DriverAppScenarioPicker = ({ value, onSelect }: DriverAppScenarioPickerProps) => (
  <div className="flex flex-col gap-3">
    <div className="flex flex-col gap-0.5">
      <Typography variant="action" className="text-neutral-black">
        Do you already have a RideMinder Driver account?
      </Typography>
      <Typography variant="paragraph" className="text-neutral-dark-gray">
        Please select one. Current or past COD / Royale drivers, choose the last option.
      </Typography>
    </div>

    <fieldset>
      <RadioGroup
        value={value}
        onChange={onSelect}
        className="flex flex-col gap-3"
        aria-label="Do you already have a RideMinder Driver account?"
      >
        {scenarioAnswers.map((answer, index) => (
          <Fragment key={answer.id}>
            {/* The two "Yes" answers sit together; an "or" splits off each of the rest. */}
            {index >= 2 && <Divider label="or" aria-hidden />}
            <Radio
              value={answer.id}
              className="group flex cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border border-neutral-mid-gray p-2 text-center outline-none hover:border-primary hover:bg-primary-light data-[checked]:border-primary data-[checked]:bg-primary-light data-[focus]:ring-2 data-[focus]:ring-primary data-[focus]:ring-offset-2"
            >
              <Typography variant="title" className="text-neutral-black group-data-[checked]:text-primary-dark">
                {answer.title}
              </Typography>
              <Typography variant="paragraph" className="text-neutral-dark-gray group-data-[checked]:text-primary-dark">
                {answer.outcome}
              </Typography>
            </Radio>
          </Fragment>
        ))}
      </RadioGroup>
    </fieldset>

    <Typography variant="caption" className="text-neutral-silver-gray">
      {scenarioHint}
    </Typography>
  </div>
);
